import { InjectionToken } from '@angular/core';
import type { UserABTestConfiguration } from './config.model';

export const AB_TESTING_SCENARIO = new InjectionToken<UserABTestConfiguration[]>('Initialisation Token for AB Testing');
